<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="part01"></a>PART ONE</h2>
<h2 class="h2a">AND A DARKNESS<br/>OVER THE EARTH</h2>
<p class="para">The Soul that rises with us, our life’s Star,<br/>Hath had elsewhere its setting<br/>And cometh from afar;<br/>Not in entire forgetfulness,<br/>And not in utter nakedness,<br/>But trailing clouds of glory do we come<br/>From God, who is our home.</p>
<p class="right-para">—<span class="smallcaps">WILLIAM WORDSWORTH</span><br/>“Ode on Intimations of Immortality from<br/>Recollections of Early Childhood”</p>
<p class="para"> </p>
<p class="right-para">There is no supernatural. There is only the natural<br/>world, and you have access to all of it. Souls are part of<br/>nature.</p>
<p class="right-para1">—The Master of the Key</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?f8eca00e